// extracted by mini-css-extract-plugin
export default {"viewEvent":"viewEvents_viewEvent__VCT-E","titleHeader":"viewEvents_titleHeader__H5YCP","title":"viewEvents_title__5ZCOX"};